import { isEmpty } from 'lodash-es';
import { Cell } from 'react-table';
import { deleteConfiguredAccount, saveEmail } from 'wisestep-api';

import { success, warning } from './NotificationMessages';

export const setDefaultEmail = async (a: Cell[], emailList, update, setNotification) => {
  try {
    if (!isEmpty(emailList) && update) {
      const defaultedEmail = emailList.filter((data) => data.isDefault);
      if (!isEmpty(defaultedEmail) && defaultedEmail[0].fromEmail === a[0].value) {
        setNotification(warning(`${a[0].value} is already your default email`));
      } else {
        if (!isEmpty(defaultedEmail)) {
          const previousDefaultedEmail = defaultedEmail[0];
          previousDefaultedEmail.isDefault = false;
          //this api will make the previouse defaulted email to nondefault email
          await saveEmail(previousDefaultedEmail);
        }
        const email = emailList.filter((data) => data.fromEmail === a[0].value);
        const data = email[0];
        data.isDefault = true;
        //this api will make the selected email as defaulted
        await saveEmail(data);
        setNotification(success(`${a[0].value} is your default email now`));
        update(true);
      }
    }
  } catch (e) {
    setNotification(warning('Something Went Wrong, Please try again'));
  }
};

export const removeEmailAccount = async (index, emailList, update, setNotification) => {
  try {
    if (!isEmpty(emailList)) {
      const defaultedEmail = emailList.filter((data) => data.isDefault);
      if (!isEmpty(defaultedEmail) && defaultedEmail[0].fromEmail === index) {
        const pendingEmails = emailList.filter((data) => !data.isDefault);
        if (!isEmpty(pendingEmails)) {
          const makeEmailDefault = pendingEmails[0];
          makeEmailDefault.isDefault = true;
          //this api will set latest email as default in case if the defaulted email is deleted
          await saveEmail(makeEmailDefault);
        }
      }
      await deleteConfiguredAccount(index);
      setNotification(success('Deleted Successfully'));
      update(true);
    }
  } catch (error) {
    setNotification(warning('Something Went Wrong, Please try again'));
  }
};
